import {charcoal} from '../sass/base/_exports.sass';

export const TextFormatIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 28.79, height = 11.2} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.65703 11.5999H6.92703L4.24703 4.5999H2.88703L0.207031 11.5999H1.47703L2.06703 9.9999H5.06703L5.65703 11.5999ZM2.54703 8.6899C2.99703 7.4799 3.32703 6.5299 3.56703 5.6199C3.80703 6.5299 4.14703 7.4799 4.58703 8.6899L4.68703 8.9499H2.44703L2.54703 8.6899Z"
        fill="black"
      />
      <path
        d="M15.9619 11.5999H17.9939L13.7059 0.399902H11.5299L7.24192 11.5999H9.27392L10.2179 9.0399H15.0179L15.9619 11.5999ZM10.9859 6.9439C11.7059 5.0079 12.2339 3.4879 12.6179 2.0319C13.0019 3.4879 13.5459 5.0079 14.2499 6.9439L14.4099 7.3599H10.8259L10.9859 6.9439Z"
        fill="black"
      />
      <rect x="18.9961" y="1.5" width="10" height="1.5" rx="0.75" fill={color} />
      <rect x="18.9961" y="4" width="6" height="1.5" rx="0.75" fill={color} />
      <rect x="18.9961" y="6.5" width="8" height="1.5" rx="0.75" fill={color} />
      <rect x="18.9961" y="9" width="5" height="1.5" rx="0.75" fill={color} />
    </svg>
  );
};
